import { AxiosPromise } from 'axios'
import axios from '../api/axios'

export const like = (id: number): AxiosPromise<void> => axios.post(`/orreca/v1/posts/${id}/like`)

export const unlike = (id: number): AxiosPromise<void> =>
  axios.post(`/orreca/v1/posts/${id}/unlike`)
